<script setup lang="ts">
const props = defineProps<{
    prefix: {
        title: string,
        desc: string,
        path: string,
        btnTxt: string,
    }
}>();
</script>

<template>
    <div class="w-75 flex flex-col items-center relative rounded-2xl bg-white overflow-hidden pb-7">
        <div class="w-full h-14 bg-secondary-500" />
        <div class="absolute top-7 rounded-full border-4 border-secondary-500 h3 px-4 py-1 bg-linear-to-b from-secondary-600 to-white">
            {{ props.prefix.title }}
        </div>
        <p class="mb-7 mt-10 text-gray-500 h4">{{ props.prefix.desc }}</p>
        <Button
            type="Secondary"
            pill
            :to="props.prefix.path"
            link
        >
            {{ props.prefix.btnTxt }}
        </Button>
    </div>
</template>